<template>
    <div>
        <!-- Loading Screen -->
        <div v-if="isLoading" class="loading-screen">
            <div class="spinner"></div>
            <p>جاري التحميل...</p>
        </div>
        <!-- Header -->
        <header class="header-container">
            <div class="container text-center">
                <!-- زر تحميل الإيصال -->
                <button class="btn-primary" @click="showModal = true">
                    انقر هنا لتحميل الإيصال
                </button>
                <!-- Modal -->
                <div
                    v-if="showModal"
                    class="modal-backdrop"
                    @click.self="showModal = false"
                >
                    <div class="modal-content">
                        <h3>تحميل الإيصال</h3>
                        <input
                            type="text"
                            v-model="nationalId"
                            placeholder="أدخل رقم بطاقة التعريف الوطنية"
                        />
                        <!-- تاريخ الازدياد -->
                        <label for="birthDate" class="mt-3"
                            >تاريخ الولادة</label
                        >
                        <!-- type="date" يعطي calendar picker تلقائياً في الكلّ المتصفحات اللي تدعموه -->
                        <input
                            id="birthDate"
                            type="date"
                            v-model="birthDate"
                            :min="minDate"
                            :max="maxDate"
                            placeholder="أختر تاريخ الولادة"
                        />
                        <button
                            @click="searchReceipt"
                            :disabled="!captchaToken"
                        >
                            بحث
                        </button>
                        <button @click="showModal = false">إغلاق</button>

                        <div
                            ref="captchaReceipt"
                            style="margin-top: 16px"
                        ></div>
                        <p
                            v-if="!captchaToken"
                            style="font-size: 0.9rem; color: gray"
                        >
                            إلزامي: يتوجب عليك وضع علامة في مربع التحقق
                            reCAPTCHA قبل المتابعة.
                        </p>
                    </div>
                </div>

                <div class="logo-container fade-in">
                    <img src="@/assets/logo.png" alt="STIR Logo" />
                </div>
                <h1 class="main-title fade-in">
                    الشركة التونسية لصناعات التكرير
                </h1>
                <h2 class="subtitle slide-in">
                    <i class="fas fa-bullhorn me-3"></i>
                    إعلان مناظرة الإنتداب 2025
                </h2>
                <br />
            </div>
        </header>

        <!-- Main Content -->
        <div class="container main-content">
            <div class="announcement-card fade-in">
                <p class="lead-text">
                    <i
                        class="fas fa-info-circle me-2"
                        style="color: #0055a5"
                    ></i>
                    تعلن الشركة التونسيّة لصناعات التكرير عن فتح مناظرة خارجيّة
                    بالملفات مشفوعة باختبار (كتابي أو تطبيقي) وشفاهي ونفسي
                    لانتداب
                    <strong style="color: #0055a5">142 </strong> عونا قارا
                    موزعين كالتالي:
                </p>

                <!-- Table (static) -->
                <div class="table-container slide-in">
                    <table class="table custom-table">
                        <thead>
                            <tr>
                                <th><i class="fas fa-users me-2"></i>السلك</th>
                                <th>
                                    <i class="fas fa-hashtag me-2"></i>عدد الخطط
                                </th>
                                <th>
                                    <i class="fas fa-file-alt me-2"></i>نصوص
                                    البلاغ
                                </th>
                                <th>
                                    <i class="fas fa-edit me-2"></i>الاطلاع على
                                    النتائج
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <i
                                        class="fas fa-graduation-cap me-2"
                                        style="color: #0055a5"
                                    ></i
                                    ><strong>الإطارات</strong>
                                </td>
                                <td><span class="position-count">22</span></td>
                                <td>
                                    <ul class="notice-names">
                                        <li>
                                            <a
                                                target="_blank"
                                                href="إعلان عن مناظرة خارجية لانتداب إطارات.pdf"
                                                class="notice-link"
                                                >الاطلاع على نصوص البلاغ</a
                                            >
                                        </li>
                                    </ul>
                                </td>
                                <td>
                                    <button disabled>النتائج الأولية تم نشرها سابقا</button>
                                    <!-- <button onclick="window.open('/01-14.html', '_blank')">النتائج الأولية</button> -->
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <i
                                        class="fas fa-cogs me-2"
                                        style="color: #0055a5"
                                    ></i
                                    ><strong>التسيير</strong>
                                </td>
                                <td><span class="position-count">32</span></td>
                                <td>
                                    <ul class="notice-names">
                                        <li>
                                            <a
                                                target="_blank"
                                                href="إعلان  عن مناظرة خارجية لانتداب أعوان تسيير.pdf"
                                                class="notice-link"
                                                >الاطلاع على نصوص البلاغ</a
                                            >
                                        </li>
                                    </ul>
                                </td>
                                <td>
                                    <router-link
                                        to="/Tab2"
                                        class="register-btn"
                                        :class="{
                                            disabled:
                                                !isRegistrationOpen('tab2'),
                                        }"
                                        :tabindex="
                                            isRegistrationOpen('tab2') ? 0 : -1
                                        "
                                    >
                                        <i class="fas fa-user-plus"></i>التسجيل
                                    </router-link>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <i
                                        class="fas fa-wrench me-2"
                                        style="color: #0055a5"
                                    ></i
                                    ><strong>التنفيذ</strong>
                                </td>
                                <td><span class="position-count">88</span></td>
                                <td>
                                    <ul class="notice-names">
                                        <li>
                                            <a
                                                target="_blank"
                                                href="إعلان عن مناظرة خارجية لانتداب أعوان تنفيذ.pdf"
                                                class="notice-link"
                                                >الاطلاع على نصوص البلاغ</a
                                            >
                                        </li>
                                    </ul>
                                </td>
                                <td>
                                    <!-- a href="/24-35.html" target="_blank">
                                        <button>نتائج الإختبارات التقنية و النفسية للمناظرة عدد 24 - 25 و 26</button>
                                    </a -->
                                    <button disabled>النتائج الأولية تم نشرها سابقا</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <!-- تحت Table -->
                <div class="registration-message fade-in">
                    <p
                        v-for="(period, key) in registrationPeriods"
                        :key="key"
                        class="mb-2"
                    >
                        <strong>
                            {{
                                key === "tab1"
                                    ? "الإطارات"
                                    : key === "tab2"
                                      ? "التسيير"
                                      : "التنفيذ"
                            }} </strong
                        >: التسجيل مفتوح من
                        <span style="color: #0055a5">{{
                            formatDate(period.start)
                        }}</span>
                        إلى
                        <span style="color: #dc3545">{{
                            formatDate(period.end)
                        }}</span>
                        —
                        <span v-if="today < period.start" style="color: #ffc107"
                            >لم يبدأ بعد</span
                        >
                        <span
                            v-else-if="today > period.end"
                            style="color: #6c757d"
                            >انتهى</span
                        >
                        <span v-else style="color: #28a745">مفتوح الآن</span>
                    </p>
                </div>

                <!-- Notes Section -->
                <div class="notes-section fade-in">
                    <h5 class="notes-title">
                        <i class="fas fa-exclamation-triangle"></i>
                        ملاحظات هامة
                    </h5>
                    <ul class="notes-list">
                        <li>
                            <i
                                class="fas fa-user-times me-2"
                                style="color: #dc3545"
                            ></i>
                            لا يمكن لأي مترشح التسجيل في أكثر من خطة واحدة.
                        </li>
                        <li>
                            <i
                                class="fas fa-calendar-alt me-2"
                                style="color: #0055a5"
                            ></i>
                            حددت آجال التسجيل وطباعة الوصل من
                            <strong>10 ديسمبر 2025</strong> إلى غاية
                            <strong>09 جانفي 2026</strong>
                            بدخول الغاية.
                        </li>
                        <li>
                            <i
                                class="fas fa-envelope me-2"
                                style="color: #28a745"
                            ></i>
                            للاستفسار يرجى إرسال بريد إلكتروني على العنوان
                            التالي:
                            <a
                                href="mailto:concours@stir.com.tn"
                                class="email-highlight"
                            >
                                <i class="fas fa-paper-plane me-1"></i>
                                concours@stir.com.tn
                            </a>
                        </li>
                        <li>
                            <i
                                class="fas fa-language me-2"
                                style="color: #ffc107"
                            ></i>
                            الرجاء ملء استمارة التسجيل باللغة العربية.
                        </li>
                        <li>
                            <i
                                class="fas fa-language me-2"
                                style="color: #ffc107"
                            ></i>
                            التثبت من أن الإيصال قد تم تنزيله بعد التسجيل
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <!-- Footer -->
        <footer class="footer">
            <div class="container">
                <p class="footer-text">
                    <i class="fas fa-copyright me-2"></i>
                    الشركة التونسية لصناعات التكرير 2025
                </p>
            </div>
        </footer>
    </div>
</template>

<script>
import ConcoursService from "@/services/concoursService.js";
import { useToast } from "vue-toastification";
import { jsPDF } from "jspdf";
import AmiriFont from "@/assets/Amiri/Amiri-Regular.ttf";

export default {
    name: "STIRRecruitment",

    data() {
        return {
            siteKey: "6LdVdS8sAAAAAAa4sTU0wZuEVgD23gZQXy03la-O",
            captchaToken: null,
            captchaRendered: false,
            isSubmitting: false,
            isLoading: true, // التحكم في شاشة التحميل
            registrationPeriods: {
                tab1: {
                    start: new Date("2025-12-10"),
                    end: new Date("2026-01-09T23:59:59"),
                },
                tab2: {
                    start: new Date("2025-12-10"),
                    end: new Date("2026-01-09T23:59:59"),
                },
                tab3: {
                    start: new Date("2025-12-10"),
                    end: new Date("2026-01-09T23:59:59"),
                },
            },
            today: new Date(),
            showModal: false,
            nationalId: "",
            birthDate: "",
            pdfData: null,
            minDate: "",
            maxDate: "",
        };
    },

    watch: {
        // when modal opens, render the captcha
        showModal(newVal) {
            if (newVal) {
                this.captchaToken = null; // reset for each open
                this.$nextTick(() => this.renderRecaptcha());
            }
        },
    },

    methods: {
        async renderRecaptcha() {
            // Don't render twice
            if (this.captchaRendered) return;

            const render = () => {
                if (!this.$refs.captchaReceipt) return;

                window.grecaptcha.render(this.$refs.captchaReceipt, {
                    sitekey: this.siteKey,
                    callback: this.onCaptchaSuccess,
                });

                this.captchaRendered = true;
            };

            // SCRIPT NOT LOADED YET → inject it
            if (!window.grecaptcha) {
                const script = document.createElement("script");
                script.src =
                    "https://www.google.com/recaptcha/api.js?render=explicit";
                script.async = true;
                script.defer = true;
                script.onload = () => {
                    // Wait for the API to be ready
                    window.grecaptcha.ready(() => render());
                };
                document.head.appendChild(script);
                return;
            }

            // SCRIPT ALREADY LOADED → use it immediately
            window.grecaptcha.ready(() => render());
        },

        onCaptchaSuccess(token) {
            this.captchaToken = token;
        },

        setDateLimits() {
            const today = new Date();
            const minDate = new Date(
                today.getFullYear() - 55,
                today.getMonth(),
                today.getDate(),
            );
            const maxDate = new Date(
                today.getFullYear() - 18,
                today.getMonth(),
                today.getDate(),
            );
            this.minDate = minDate.toISOString().split("T")[0];
            this.maxDate = maxDate.toISOString().split("T")[0];
        },

        isRegistrationOpen(tabKey) {
            const { start, end } = this.registrationPeriods[tabKey];
            return this.today >= start && this.today <= end;
        },

        formatDate(date) {
            return date.toLocaleDateString("ar-TN", {
                day: "2-digit",
                month: "long",
                year: "numeric",
            });
        },

        arrayBufferToBase64(buffer) {
            let binary = "";
            const bytes = new Uint8Array(buffer);
            const chunkSize = 0x8000;
            for (let i = 0; i < bytes.length; i += chunkSize) {
                const chunk = bytes.subarray(i, i + chunkSize);
                binary += String.fromCharCode.apply(null, chunk);
            }
            return btoa(binary);
        },

        async getImageBase64(imgPath) {
            const response = await fetch(imgPath);
            const blob = await response.blob();
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            });
        },

        async searchReceipt() {
            const toast = useToast();

            if (!this.captchaToken) return; // safety (button is already disabled)

            this.isSubmitting = true;

            if (!this.nationalId) {
                toast.error("المرجو إدخال رقم بطاقة التعريف!");
                return;
            }
            if (!this.birthDate) {
                toast.error("المرجو إدخال تاريخ الولادة!");
                return;
            }
            this.pdfData = (
                await ConcoursService.searchByNationalIdAndBirthDate({
                    nationalId: this.nationalId,
                    birthDate: this.birthDate,
                    captchaToken: this.captchaToken,
                })
            ).data;
            if (!this.pdfData.found) {
                toast.error("الرجاء التثبت من المعطيات");
            } else {
                try {
                    toast.success("تم البحث عن الإيصال!");
                    // 🔹 تحميل الخط العربي وتحويله إلى Base64
                    const fontResponse = await fetch(AmiriFont);
                    const fontBuffer = await fontResponse.arrayBuffer();
                    const fontBase64 = this.arrayBufferToBase64(fontBuffer);

                    const doc = new jsPDF({
                        orientation: "p",
                        unit: "mm",
                        format: "a4",
                    });

                    // 🔹 تحميل الخط العربي الجديد
                    doc.addFileToVFS("Scheherazade-Regular.ttf", fontBase64);
                    doc.addFont(
                        "Scheherazade-Regular.ttf",
                        "Scheherazade",
                        "normal",
                    );
                    doc.setFont("Scheherazade"); // الخط الجديد

                    // 🔹 أبعاد الصفحة
                    const pageWidth = 210;
                    let y = 2;

                    const logoBase64 = await this.getImageBase64(
                        require("@/assets/logo.png"),
                    );
                    const logoWidth = 20;
                    const logoHeight = 20;
                    const xLogo = (pageWidth - logoWidth) / 2;
                    doc.addImage(
                        logoBase64,
                        "PNG",
                        xLogo,
                        y,
                        logoWidth,
                        logoHeight,
                    );
                    y += logoHeight + 15;

                    // 🔹 كتابة العنوان تحت اللوغو في الوسط
                    doc.setFontSize(17);

                    doc.text(
                        "إيصال التسجيل في مناظرة الإنتداب الخاصة بالشركة التونسية لصناعات التكرير لسنة 2025",
                        pageWidth / 2,
                        y,
                        { align: "center" },
                    );
                    const data = this.pdfData[0];
                    console.log("pdf data:", this.pdfData);
                    console.log("PDF Data in pdf:", data);

                    doc.setFontSize(15);
                    // 🔹 تغيير اللون للأحمر
                    doc.setTextColor(255, 0, 0);
                    // 🔹 رقم المناظرة
                    doc.text(
                        `رقم المناظرة : ${data.examId}`,
                        pageWidth / 2,
                        y + 15,
                        { align: "center" },
                    );
                    doc.text(
                        `رقم التسجيل : ${data.num_inscription || "غير محدد"}`,
                        pageWidth / 2,
                        y + 25,
                        { align: "center" },
                    );
                    y += 15;

                    doc.setTextColor(0, 0, 0);
                    // 🔹 بعد العنوان، نكتب البيانات الشخصية والأكاديمية مباشرة
                    doc.setFontSize(12);

                    console.log("PDF Data in pdf:", data);
                    y += 22;
                    // 🔹 كتابة المعلومات الشخصية
                    const personalFields = [
                        { label: "الاسم الكامل", key: "fullName" },
                        { label: "اسم الأب", key: "fatherName" },
                        { label: "تاريخ الولادة", key: "birthDate" },
                        { label: "الجنس", key: "sex" },
                        { label: "مكان الولادة", key: "birthPlace" },
                        { label: "الولاية", key: "governorate" },
                        { label: "رقم بطاقة التعريف", key: "nationalId" },
                        { label: "تاريخ الإصدار", key: "issueDate" },
                        { label: "العنوان", key: "address" },
                        { label: "الترقيم البريدي", key: "postalCode" },
                        { label: "رقم الهاتف", key: "phone" },
                        { label: "البريد الإلكتروني", key: "email" },
                    ];

                    personalFields.forEach((field) => {
                        doc.text(
                            `${field.label}: ${data[field.key]}`,
                            pageWidth - 20,
                            y,
                            { align: "right" },
                        );
                        y += 10;
                    });

                    const academicIds = [
                        "25/01",
                        "25/02",
                        "25/03",
                        "25/04",
                        "25/05",
                        "25/06",
                        "25/07",
                        "25/08",
                        "25/09",
                        "25/10",
                        "25/11",
                        "25/12",
                        "25/13",
                        "25/14",
                    ];
                    if (academicIds.includes(data.examId)) {
                        const academicFields = [
                            {
                                label: "اختصاص شهادة الباكالوريا",
                                key: "bacSpecialization",
                            },
                            {
                                label: "المعدل النهائي للباكالوريا",
                                key: "bacScore",
                            },
                            {
                                label: "الشهادة العلمية المتحصَّل عليها",
                                key: "universityDegree",
                            },
                            { label: "المؤسسة الجامعية", key: "university" },
                            { label: "سنة التخرج", key: "graduationYear" },
                            {
                                label: "معدل سنة التخرج",
                                key: "graduationScore",
                            },
                        ];
                        const marginRight = 20;
                        academicFields.forEach((field) => {
                            doc.text(
                                `${field.label}: ${data.extra_data[field.key]}`,
                                pageWidth - marginRight,
                                y,
                                { align: "right" },
                            );
                            y += 10;
                        });
                    }

                    const marginRight = 20;

                    if (data.examId === "25/15") {
                        doc.text(
                            `نوع الشهادة: ${data.extra_data.diplomaType || "غير محدد"}`,
                            pageWidth - marginRight,
                            y,
                            { align: "right" },
                        );
                        y += 10;

                        if (data.extra_data.diplomaType === "بكالوريا") {
                            const bacFields = [
                                {
                                    label: "شهادة البكالوريا",
                                    key: "bacSpecialization",
                                },
                                {
                                    label: "المعدل النهائي للباكالوريا",
                                    key: "bacScore",
                                },
                            ];
                            bacFields.forEach((field) => {
                                doc.text(
                                    `${field.label}: ${data.extra_data[field.key] || "غير محدد"}`,
                                    pageWidth - marginRight,
                                    y,
                                    { align: "right" },
                                );
                                y += 10;
                            });
                        }

                        if (data.extra_data.diplomaType === "مؤهل تقني مهني") {
                            const techFields = [
                                {
                                    label: "الاختصاص",
                                    key: "techSpecialization",
                                },
                                {
                                    label: "مؤسسة التكوين المهني",
                                    key: "trainingCenter",
                                },
                                {
                                    label: "سنة الحصول على شهادة مؤهَّل تقني مهني",
                                    key: "graduationYear",
                                },
                                {
                                    label: "معدل الحصول على شهادة مؤهَّل تقني مهني",
                                    key: "techScore",
                                },
                            ];
                            techFields.forEach((field) => {
                                doc.text(
                                    `${field.label}: ${data.extra_data[field.key] || "غير محدد"}`,
                                    pageWidth - marginRight,
                                    y,
                                    { align: "right" },
                                );
                                y += 10;
                            });
                        }
                    }

                    if (data.examId === "25/16") {
                        doc.text(
                            `اختصاص شهادة الباكالوريا: ${data.extra_data.bacSpecialization || "غير محدد"}`,
                            pageWidth - marginRight,
                            y,
                            { align: "right" },
                        );
                        y += 10;

                        doc.text(
                            `المعدل النهائي للباكالوريا: ${data.extra_data.bacScore || "غير محدد"}`,
                            pageWidth - marginRight,
                            y,
                            { align: "right" },
                        );
                        y += 10;

                        doc.text(
                            `نوع الشهادة: ${data.extra_data.degreeType || "غير محدد"}`,
                            pageWidth - marginRight,
                            y,
                            { align: "right" },
                        );
                        y += 10;

                        if (
                            data.extra_data.degreeType ===
                            "تقني سامي مساعد مديرية"
                        ) {
                            const bacFields = [
                                {
                                    label: "المؤسسة الجامعية",
                                    key: "university",
                                },
                                { label: "سنة التخرج", key: "graduationYear" },
                                {
                                    label: "معدل سنة التخرج",
                                    key: "graduationScore",
                                },
                            ];
                            bacFields.forEach((field) => {
                                doc.text(
                                    `${field.label}: ${data.extra_data[field.key] || "غير محدد"}`,
                                    pageWidth - marginRight,
                                    y,
                                    { align: "right" },
                                );
                                y += 10;
                            });
                        }

                        if (data.extra_data.degreeType === "شهادة معادلة") {
                            const techFields = [
                                {
                                    label: "المؤسسة الجامعية",
                                    key: "university",
                                },
                                {
                                    label: "الشهادة المحصل عليها",
                                    key: "obtainedDegree",
                                },
                                { label: "سنة التخرج", key: "graduationYear" },
                                {
                                    label: "معدل سنة التخرج",
                                    key: "graduationScore",
                                },
                            ];
                            techFields.forEach((field) => {
                                doc.text(
                                    `${field.label}: ${data.extra_data[field.key] || "غير محدد"}`,
                                    pageWidth - marginRight,
                                    y,
                                    { align: "right" },
                                );
                                y += 10;
                            });
                        }
                    }

                    // 🔹 كتابة المعلومات الأكاديمية إذا كان المعرف 25/17
                    if (data.examId === "25/17") {
                        // الباك
                        doc.text(
                            `اختصاص شهادة الباكالوريا: ${data.extra_data.bacSpecialization17 || "غير محدد"}`,
                            pageWidth - marginRight,
                            y,
                            { align: "right" },
                        );
                        y += 10;

                        doc.text(
                            `المعدل النهائي للباكالوريا: ${data.extra_data.bacScore17 || "غير محدد"}`,
                            pageWidth - marginRight,
                            y,
                            { align: "right" },
                        );
                        y += 10;

                        doc.text(
                            `نوع الشهادة: ${data.extra_data.degreeType17 || "غير محدد"}`,
                            pageWidth - marginRight,
                            y,
                            { align: "right" },
                        );
                        y += 10;

                        // في حالة إجازة
                        if (data.extra_data.degreeType17 === "إجازة") {
                            const licenseFields = [
                                {
                                    label: "المؤسسة الجامعية",
                                    key: "university17",
                                },
                                {
                                    label: "الشهادة المحصل عليها",
                                    key: "obtainedDegree17",
                                },
                                {
                                    label: "سنة التخرج",
                                    key: "graduationYear17",
                                },
                                {
                                    label: "معدل سنة التخرج",
                                    key: "graduationScore17",
                                },
                            ];
                            licenseFields.forEach((field) => {
                                doc.text(
                                    `${field.label}: ${data.extra_data[field.key] || "غير محدد"}`,
                                    pageWidth - marginRight,
                                    y,
                                    { align: "right" },
                                );
                                y += 10;
                            });
                        }

                        // في حالة مؤهل تقني سامي في الكيمياء
                        if (
                            data.extra_data.degreeType17 ===
                            "مؤهل تقني سامي في الكيمياء"
                        ) {
                            const techFields = [
                                {
                                    label: "المؤسسة الجامعية",
                                    key: "institution17",
                                },
                                {
                                    label: "سنة التخرج",
                                    key: "graduationYear17",
                                },
                                {
                                    label: "معدل سنة التخرج",
                                    key: "graduationScore17",
                                },
                            ];
                            techFields.forEach((field) => {
                                doc.text(
                                    `${field.label}: ${data.extra_data[field.key] || "غير محدد"}`,
                                    pageWidth - marginRight,
                                    y,
                                    { align: "right" },
                                );
                                y += 10;
                            });
                        }
                    }

                    // 🔹 كتابة المعلومات الأكاديمية إذا كان المعرف 25/18
                    if (data.examId === "25/18") {
                        // الباك
                        doc.text(
                            `اختصاص شهادة الباكالوريا: ${data.extra_data.bacSpecialization18 || "غير محدد"}`,
                            pageWidth - marginRight,
                            y,
                            { align: "right" },
                        );
                        y += 10;

                        doc.text(
                            `المعدل النهائي للباكالوريا: ${data.extra_data.bacScore18 || "غير محدد"}`,
                            pageWidth - marginRight,
                            y,
                            { align: "right" },
                        );
                        y += 10;

                        doc.text(
                            `نوع الشهادة: ${data.extra_data.degreeType18 || "غير محدد"}`,
                            pageWidth - marginRight,
                            y,
                            { align: "right" },
                        );
                        y += 10;

                        // في حالة إجازة
                        if (data.extra_data.degreeType18 === "إجازة") {
                            const licenseFields = [
                                {
                                    label: "المؤسسة الجامعية",
                                    key: "university18",
                                },
                                {
                                    label: "الشهادة المتحصل عليها",
                                    key: "obtainedDegree18",
                                },
                                {
                                    label: "سنة التخرج",
                                    key: "graduationYear18",
                                },
                                {
                                    label: "معدل سنة التخرج",
                                    key: "graduationScore18",
                                },
                            ];
                            licenseFields.forEach((field) => {
                                doc.text(
                                    `${field.label}: ${data.extra_data[field.key] || "غير محدد"}`,
                                    pageWidth - marginRight,
                                    y,
                                    { align: "right" },
                                );
                                y += 10;
                            });
                        }

                        // في حالة مؤهل تقني سامي في الهندسة الميكانيكية
                        if (
                            data.extra_data.degreeType18 ===
                            "مؤهل تقني سامي في الهندسة الميكانيكية"
                        ) {
                            const techFields = [
                                {
                                    label: "المؤسسة الجامعية",
                                    key: "university18",
                                },
                                {
                                    label: "سنة التخرج",
                                    key: "graduationYear18",
                                },
                                {
                                    label: "معدل سنة التخرج",
                                    key: "graduationScore18",
                                },
                            ];
                            techFields.forEach((field) => {
                                doc.text(
                                    `${field.label}: ${data.extra_data[field.key] || "غير محدد"}`,
                                    pageWidth - marginRight,
                                    y,
                                    { align: "right" },
                                );
                                y += 10;
                            });
                        }
                    }

                    // 🔹 كتابة المعلومات الأكاديمية إذا كان المعرف 25/19
                    if (data.examId === "25/19") {
                        // الباك
                        doc.text(
                            `اختصاص شهادة الباكالوريا: ${data.extra_data.bacSpecialization19 || "غير محدد"}`,
                            pageWidth - marginRight,
                            y,
                            { align: "right" },
                        );
                        y += 10;

                        doc.text(
                            `المعدل النهائي للباكالوريا: ${data.extra_data.bacScore19 || "غير محدد"}`,
                            pageWidth - marginRight,
                            y,
                            { align: "right" },
                        );
                        y += 10;

                        doc.text(
                            `نوع الشهادة: ${data.extra_data.degreeType19 || "غير محدد"}`,
                            pageWidth - marginRight,
                            y,
                            { align: "right" },
                        );
                        y += 10;

                        // في حالة إجازة
                        if (data.extra_data.degreeType19 === "إجازة") {
                            const licenseFields = [
                                {
                                    label: "المؤسسة الجامعية",
                                    key: "university19",
                                },
                                {
                                    label: "الشهادة المتحصل عليها",
                                    key: "obtainedDegree19",
                                },
                                {
                                    label: "سنة التخرج",
                                    key: "graduationYear19",
                                },
                                {
                                    label: "معدل سنة التخرج",
                                    key: "graduationScore19",
                                },
                            ];
                            licenseFields.forEach((field) => {
                                doc.text(
                                    `${field.label}: ${data.extra_data[field.key] || "غير محدد"}`,
                                    pageWidth - marginRight,
                                    y,
                                    { align: "right" },
                                );
                                y += 10;
                            });
                        }

                        // في حالة مؤهل تقني سامي في الهندسة الكهربائية
                        if (
                            data.extra_data.degreeType19 ===
                            "مؤهل تقني سامي في الهندسة الكهربائية"
                        ) {
                            const techFields = [
                                {
                                    label: "المؤسسة الجامعية",
                                    key: "university19",
                                },
                                {
                                    label: "سنة التخرج",
                                    key: "graduationYear19",
                                },
                                {
                                    label: "معدل سنة التخرج",
                                    key: "graduationScore19",
                                },
                            ];
                            techFields.forEach((field) => {
                                doc.text(
                                    `${field.label}: ${data.extra_data[field.key] || "غير محدد"}`,
                                    pageWidth - marginRight,
                                    y,
                                    { align: "right" },
                                );
                                y += 10;
                            });
                        }
                    }

                    // 🔹 كتابة المعلومات الأكاديمية إذا كان المعرف 25/20
                    if (data.examId === "25/20") {
                        // الباك
                        doc.text(
                            `اختصاص شهادة الباكالوريا: ${data.extra_data.bacSpecialization20 || "غير محدد"}`,
                            pageWidth - marginRight,
                            y,
                            { align: "right" },
                        );
                        y += 10;

                        doc.text(
                            `معدل الباكالوريا: ${data.extra_data.bacScore20 || "غير محدد"}`,
                            pageWidth - marginRight,
                            y,
                            { align: "right" },
                        );
                        y += 10;

                        doc.text(
                            `نوع الشهادة: ${data.extra_data.degreeType20 || "غير محدد"}`,
                            pageWidth - marginRight,
                            y,
                            { align: "right" },
                        );
                        y += 10;

                        // في حالة إجازة
                        if (data.extra_data.degreeType20 === "إجازة") {
                            const licenseFields = [
                                {
                                    label: "المؤسسة الجامعية",
                                    key: "university20",
                                },
                                {
                                    label: "الشهادة المتحصل عليها",
                                    key: "obtainedDegree20",
                                },
                                {
                                    label: "سنة التخرج",
                                    key: "graduationYear20",
                                },
                                {
                                    label: "معدل سنة التخرج",
                                    key: "graduationScore20",
                                },
                            ];
                            licenseFields.forEach((field) => {
                                doc.text(
                                    `${field.label}: ${data.extra_data[field.key] || "غير محدد"}`,
                                    pageWidth - marginRight,
                                    y,
                                    { align: "right" },
                                );
                                y += 10;
                            });
                        }

                        // في حالة مؤهل تقني سامي في التصرف في الموارد البشرية
                        if (
                            data.extra_data.degreeType20 ===
                            "مؤهل تقني سامي في التصرف في الموارد البشرية"
                        ) {
                            const techFields = [
                                {
                                    label: "المؤسسة الجامعية",
                                    key: "university20",
                                },
                                {
                                    label: "سنة التخرج",
                                    key: "graduationYear20",
                                },
                                {
                                    label: "معدل سنة التخرج",
                                    key: "graduationScore20",
                                },
                            ];
                            techFields.forEach((field) => {
                                doc.text(
                                    `${field.label}: ${data.extra_data[field.key] || "غير محدد"}`,
                                    pageWidth - marginRight,
                                    y,
                                    { align: "right" },
                                );
                                y += 10;
                            });
                        }
                    }

                    if (data.examId === "25/21") {
                        // الباك
                        doc.text(
                            `اختصاص شهادة الباكالوريا: ${data.extra_data.bacType21 || "غير محدد"}`,
                            pageWidth - marginRight,
                            y,
                            { align: "right" },
                        );
                        y += 10;

                        doc.text(
                            `معدل الباكالوريا: ${data.extra_data.bacScore21 || "غير محدد"}`,
                            pageWidth - marginRight,
                            y,
                            { align: "right" },
                        );
                        y += 10;

                        doc.text(
                            `نوع الشهادة: ${data.extra_data.degreeType21 || "غير محدد"}`,
                            pageWidth - marginRight,
                            y,
                            { align: "right" },
                        );
                        y += 10;

                        // في حالة إجازة
                        if (data.extra_data.degreeType21 === "إجازة") {
                            const licenseFields = [
                                {
                                    label: "المؤسسة الجامعية",
                                    key: "university21",
                                },
                                {
                                    label: "الشهادة المتحصل عليها",
                                    key: "obtainedDegree21",
                                },
                                {
                                    label: "سنة التخرج",
                                    key: "graduationYear21",
                                },
                                {
                                    label: "معدل سنة التخرج",
                                    key: "graduationScore21",
                                },
                            ];
                            licenseFields.forEach((field) => {
                                doc.text(
                                    `${field.label}: ${data.extra_data[field.key] || "غير محدد"}`,
                                    pageWidth - marginRight,
                                    y,
                                    { align: "right" },
                                );
                                y += 10;
                            });
                        }

                        // في حالة مؤهل تقني سامي في التصرف في الموارد البشرية
                        if (
                            data.extra_data.degreeType21 ===
                            "مؤهّل تقني سامٍ في الإلكترونيك والكهروتقنية والآلية"
                        ) {
                            const techFields = [
                                {
                                    label: "المؤسسة الجامعية",
                                    key: "university21",
                                },
                                {
                                    label: "سنة التخرج",
                                    key: "graduationYear21",
                                },
                                {
                                    label: "معدل سنة التخرج",
                                    key: "graduationScore21",
                                },
                            ];
                            techFields.forEach((field) => {
                                doc.text(
                                    `${field.label}: ${data.extra_data[field.key] || "غير محدد"}`,
                                    pageWidth - marginRight,
                                    y,
                                    { align: "right" },
                                );
                                y += 10;
                            });
                        }
                    }

                    if (data.examId === "25/22") {
                        // الباك
                        doc.text(
                            `اختصاص شهادة الباكالوريا: ${data.extra_data.bacType22 || "غير محدد"}`,
                            pageWidth - marginRight,
                            y,
                            { align: "right" },
                        );
                        y += 10;

                        doc.text(
                            `معدل الباكالوريا: ${data.extra_data.bacScore22 || "غير محدد"}`,
                            pageWidth - marginRight,
                            y,
                            { align: "right" },
                        );
                        y += 10;

                        doc.text(
                            `نوع الشهادة: ${data.extra_data.degreeType22 || "غير محدد"}`,
                            pageWidth - marginRight,
                            y,
                            { align: "right" },
                        );
                        y += 10;

                        // في حالة إجازة
                        if (data.extra_data.degreeType22 === "إجازة") {
                            const licenseFields = [
                                {
                                    label: "المؤسسة الجامعية",
                                    key: "university22",
                                },
                                {
                                    label: "الشهادة المتحصل عليها",
                                    key: "obtainedDegree22",
                                },
                                {
                                    label: "سنة التخرج",
                                    key: "graduationYear22",
                                },
                                {
                                    label: "معدل سنة التخرج",
                                    key: "graduationScore22",
                                },
                            ];
                            licenseFields.forEach((field) => {
                                doc.text(
                                    `${field.label}: ${data.extra_data[field.key] || "غير محدد"}`,
                                    pageWidth - marginRight,
                                    y,
                                    { align: "right" },
                                );
                                y += 10;
                            });
                        }

                        // في حالة مؤهل تقني سامي في التصرف في الموارد البشرية
                        if (
                            data.extra_data.degreeType22 ===
                            "مؤهل تقني سامي في إدارة الأعمال: المحاسبة والمالية"
                        ) {
                            const techFields = [
                                {
                                    label: "المؤسسة الجامعية",
                                    key: "university22",
                                },
                                {
                                    label: "سنة التخرج",
                                    key: "graduationYear22",
                                },
                                {
                                    label: "معدل سنة التخرج",
                                    key: "graduationScore22",
                                },
                            ];
                            techFields.forEach((field) => {
                                doc.text(
                                    `${field.label}: ${data.extra_data[field.key] || "غير محدد"}`,
                                    pageWidth - marginRight,
                                    y,
                                    { align: "right" },
                                );
                                y += 10;
                            });
                        }
                    }

                    if (data.examId === "25/23") {
                        doc.text(
                            `شهادة مؤهل تقني مهني : ${data.extra_data.techCert23 || "غير محدد"}`,
                            pageWidth - marginRight,
                            y,
                            { align: "right" },
                        );
                        y += 10;

                        doc.text(
                            `مؤسسة التكوين المهني : ${data.extra_data.trainingCenter23 || "غير محدد"}`,
                            pageWidth - marginRight,
                            y,
                            { align: "right" },
                        );
                        y += 10;

                        doc.text(
                            `سنة الحصول على شهادة مؤهل تقني مهني: ${data.extra_data.graduationYear23 || "غير محدد"}`,
                            pageWidth - marginRight,
                            y,
                            { align: "right" },
                        );
                        y += 10;

                        doc.text(
                            `معدل الحصول على شهادة مؤهل تقني مهني : ${data.extra_data.graduationScore23 || "غير محدد"}`,
                            pageWidth - marginRight,
                            y,
                            { align: "right" },
                        );
                        y += 10;
                    }

                    if (data.examId === "25/24") {
                        doc.text(
                            `المستوى الدراسي : ${data.extra_data.studyLevel24 || "غير محدد"}`,
                            pageWidth - marginRight,
                            y,
                            { align: "right" },
                        );
                        y += 10;

                        doc.text(
                            `المعدل النهائي للشهادة المدرسية : ${data.extra_data.finalScore24 || "غير محدد"}`,
                            pageWidth - marginRight,
                            y,
                            { align: "right" },
                        );
                        y += 10;

                        doc.text(
                            `الشهادة العسكرية : ${data.extra_data.militaryCertOption24 || "غير محدد"}`,
                            pageWidth - marginRight,
                            y,
                            { align: "right" },
                        );
                        y += 10;
                    }

                    if (data.examId === "25/25" || data.examId === "25/26") {
                        doc.text(
                            `المستوى الدراسي : ${data.extra_data.studyLevel25_26 || "غير محدد"}`,
                            pageWidth - marginRight,
                            y,
                            { align: "right" },
                        );
                        y += 10;

                        doc.text(
                            `المعدل النهائي للنجاح بالشهادة المدرسية : ${data.extra_data.finalScore25_26 || "غير محدد"}`,
                            pageWidth - marginRight,
                            y,
                            { align: "right" },
                        );
                        y += 10;

                        doc.text(
                            `الشهادة العسكرية : ${data.extra_data.militaryCertOption25_26 || "غير محدد"}`,
                            pageWidth - marginRight,
                            y,
                            { align: "right" },
                        );
                        y += 10;
                    }

                    if (data.examId === "25/27") {
                        doc.text(
                            `المستوى الدراسي : ${data.extra_data.studyLevel25_27 || "غير محدد"}`,
                            pageWidth - marginRight,
                            y,
                            { align: "right" },
                        );
                        y += 10;

                        doc.text(
                            `المعدل النهائي للنجاح بالشهادة المدرسية : ${data.extra_data.finalScore25_27 || "غير محدد"}`,
                            pageWidth - marginRight,
                            y,
                            { align: "right" },
                        );
                        y += 10;

                        doc.text(
                            `شهائد التكوين المهني مع شهادة تنظير: ${data.extra_data.professionalWarning25_27 || "غير محدد"}`,
                            pageWidth - marginRight,
                            y,
                            { align: "right" },
                        );
                        y += 10;
                    }

                    if (data.examId === "25/28") {
                        doc.text(
                            `المستوى الدراسي : ${data.extra_data.studyLevel25_28 || "غير محدد"}`,
                            pageWidth - marginRight,
                            y,
                            { align: "right" },
                        );
                        y += 10;

                        doc.text(
                            `المعدل النهائي للنجاح بالشهادة المدرسية : ${data.extra_data.finalScore25_28 || "غير محدد"}`,
                            pageWidth - marginRight,
                            y,
                            { align: "right" },
                        );
                        y += 10;

                        doc.text(
                            `شهائد التكوين المهني مع شهادة تنظير: ${data.extra_data.professionalWarning25_28 || "غير محدد"}`,
                            pageWidth - marginRight,
                            y,
                            { align: "right" },
                        );
                        y += 10;
                    }

                    if (data.examId === "25/29") {
                        doc.text(
                            `المستوى الدراسي : ${data.extra_data.studyLevel25_29 || "غير محدد"}`,
                            pageWidth - marginRight,
                            y,
                            { align: "right" },
                        );
                        y += 10;

                        doc.text(
                            `المعدل النهائي للنجاح بالشهادة المدرسية : ${data.extra_data.finalScore25_29 || "غير محدد"}`,
                            pageWidth - marginRight,
                            y,
                            { align: "right" },
                        );
                        y += 10;

                        doc.text(
                            `شهائد التكوين المهني مع شهادة تنظير: ${data.extra_data.professionalWarning25_29 || "غير محدد"}`,
                            pageWidth - marginRight,
                            y,
                            { align: "right" },
                        );
                        y += 10;
                    }

                    if (
                        data.examId === "25/30" ||
                        data.examId === "25/31" ||
                        data.examId === "25/32" ||
                        data.examId === "25/33"
                    ) {
                        doc.text(
                            `المعدل النهائي للنجاح بالشهادة المدرسية : ${data.extra_data.finalScore25_30_33 || "غير محدد"}`,
                            pageWidth - marginRight,
                            y,
                            { align: "right" },
                        );
                        y += 10;
                    }

                    if (data.examId === "25/34" || data.examId === "25/35") {
                        doc.text(
                            `المعدل النهائي للنجاح بالشهادة المدرسية : ${data.extra_data.finalScore25_34_35 || "غير محدد"}`,
                            pageWidth - marginRight,
                            y,
                            { align: "right" },
                        );
                        y += 10;

                        doc.text(
                            `رخصة السياقة من الصنف B+C+D: ${data.extra_data.drivingLicense25_34_35 || "غير محدد"}`,
                            pageWidth - marginRight, // البداية من أقصى اليمين
                            y,
                            { align: "right" }, // محاذاة من اليمين
                        );
                        y += 10;
                    }

                    let scoreFormula = "";

                    if (academicIds.includes(data.examId)) {
                        scoreFormula =
                            ")معدل سنةالتخرج × 1.5( + )معدل شهادةالباكالوريا × 1(";
                    } else if (data.examId === "25/15") {
                        if (data.extra_data.diplomaType === "مؤهل تقني مهني") {
                            scoreFormula = ")معدل مؤهل تقني مهني × 2.5(";
                        } else if (data.extra_data.diplomaType === "بكالوريا") {
                            scoreFormula = ")معدل شهادةالباكالوريا × 2.5()";
                        }
                    } else if (data.examId === "25/16") {
                        scoreFormula =
                            ")معدل سنةالتخرج × 1.5( + )معدل شهادةالباكالوريا × 1(";
                    } else if (
                        [
                            "25/17",
                            "25/18",
                            "25/19",
                            "25/20",
                            "25/21",
                            "25/22",
                        ].includes(data.examId)
                    ) {
                        scoreFormula =
                            ")معدل التخرج × 1.5( + )معدل الباكالوريا × 1(";
                    } else if (data.examId === "25/23") {
                        scoreFormula = ")معدل شهادة مؤهل تقني مهني × 2.5(";
                    }

                    doc.text(
                        `النقاط المتحصل عليها${scoreFormula ? " )" + scoreFormula + "(" : ""}: ${data.score || "لا شئ"}`,
                        pageWidth - marginRight,
                        y,
                        { align: "right" },
                    );
                    y += 10;

                    // 🔹 حفظ PDF
                    doc.save("registration.pdf");
                    localStorage.clear();

                    // 🔹 إشعار النجاح
                    toast.success("تم إرسال البيانات وإنشاء ملف PDF بنجاح!");

                    // 🔹 إعادة التوجيه بعد 5 ثواني
                    setTimeout(() => this.$router.push("/"), 5000);

                    this.showModal = false; // يغلق المودال بعد البحث
                } catch (error) {
                    console.error("خطأ في إنشاء PDF:", error);
                    toast.error("حدث خطأ أثناء إنشاء الملف. حاول مرة أخرى.");
                }
            }
        },
    },

    mounted() {
        // if the modal is initially visible for some reason
        if (this.showModal) {
            this.renderRecaptcha();
        }
        this.setDateLimits();
        // 1️⃣ تأثير fade-out لشاشة التحميل بعد 2 ثواني
        setTimeout(() => {
            const loadingScreen = document.querySelector(".loading-screen");
            if (loadingScreen) {
                loadingScreen.style.transition = "opacity 0.8s ease";
                loadingScreen.style.opacity = "0";
                setTimeout(() => {
                    this.isLoading = false;
                }, 800);
            }
        }, 2000);

        // 2️⃣ Scroll animation للعناصر fade-in و slide-in
        const observerOptions = {
            threshold: 0.1,
            rootMargin: "0px 0px -50px 0px",
        };
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.style.opacity = "1";
                    entry.target.style.transform = "translateY(0)";
                }
            });
        }, observerOptions);

        document.querySelectorAll(".fade-in, .slide-in").forEach((el) => {
            el.style.opacity = "0";
            el.style.transform = "translateY(30px)";
            el.style.transition = "all 0.6s ease-out";
            observer.observe(el);
        });

        // 3️⃣ Hover animation للجدول (مزيد عمق)
        const tableRows = document.querySelectorAll(".custom-table tbody tr");
        tableRows.forEach((row) => {
            row.addEventListener("mouseenter", () => {
                row.style.transform = "translateY(-3px)";
                row.style.boxShadow = "0 8px 25px rgba(0, 85, 165, 0.15)";
            });
            row.addEventListener("mouseleave", () => {
                row.style.transform = "translateY(0)";
                row.style.boxShadow = "none";
            });
        });

        // 4️⃣ Hover animation للأزرار
        const buttons = document.querySelectorAll(".register-btn");
        buttons.forEach((btn) => {
            btn.addEventListener("mouseenter", () => {
                btn.style.transform = "translateY(-2px)";
                btn.style.boxShadow = "0 10px 20px rgba(0,85,165,0.4)";
            });
            btn.addEventListener("mouseleave", () => {
                btn.style.transform = "translateY(0)";
                btn.style.boxShadow = "0 5px 15px rgba(0,85,165,0.3)";
            });
        });

        // 5️⃣ حركة الخلفية متاع body (دوائر صغيرة تتحرك تدريجياً)
        let offset = 0;
        function animateBackground() {
            offset += 0.1;
            document.body.style.backgroundPosition = `${offset}px ${offset}px, ${offset * 0.5}px ${offset * 0.7}px, ${-offset * 0.3}px ${offset * 0.5}px`;
            requestAnimationFrame(animateBackground);
        }
        animateBackground();
    },
};
</script>

<style scoped>
/* Reset and base */
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    direction: rtl;
}

body {
    font-family: "Tajawal", sans-serif;
    background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
    color: #1a202c;
    line-height: 1.6;
    overflow-x: hidden;
}

/* Animated background */
body::before {
    content: "";
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background:
        radial-gradient(
            circle at 20% 50%,
            rgba(0, 85, 165, 0.05) 0%,
            transparent 50%
        ),
        radial-gradient(
            circle at 80% 20%,
            rgba(0, 51, 102, 0.05) 0%,
            transparent 50%
        ),
        radial-gradient(
            circle at 40% 80%,
            rgba(255, 193, 7, 0.03) 0%,
            transparent 50%
        );
    z-index: -1;
}

/* Loading Screen */
.loading-screen {
    position: fixed;
    inset: 0;
    background: linear-gradient(135deg, #003366, #0055a5);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: white;
    z-index: 9999;
}

.spinner {
    width: 50px;
    height: 50px;
    border: 4px solid rgba(255, 255, 255, 0.3);
    border-top: 4px solid #ffd700;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-bottom: 20px;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}

/* Header */
.header-container {
    background: linear-gradient(135deg, #003366 0%, #0055a5 50%, #0066cc 100%);
    position: relative;
    overflow: hidden;
    padding: 0;
    box-shadow: 0 10px 40px rgba(0, 51, 102, 0.3);
}

.header-container::before {
    content: "";
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background:
        radial-gradient(circle, rgba(255, 255, 255, 0.1) 1px, transparent 1px),
        radial-gradient(circle, rgba(255, 255, 255, 0.05) 1px, transparent 1px);
    background-size:
        50px 50px,
        25px 25px;
    animation: float 20s ease-in-out infinite;
}

@keyframes float {
    0%,
    100% {
        transform: translateY(0px) rotate(0deg);
    }

    50% {
        transform: translateY(-20px) rotate(2deg);
    }
}

.logo-container {
    position: relative;
    z-index: 2;
    margin-bottom: 1px;
    margin-top: 30px;
}

.logo-container img {
    width: 120px;
    height: auto;
    filter: drop-shadow(0 5px 15px rgba(255, 255, 255, 0.3));
    transition: transform 0.3s ease;
}

.logo-container img:hover {
    transform: scale(1.05);
}

.main-title {
    font-size: 3.5rem;
    font-weight: 900;
    color: white;
    text-shadow: 2px 2px 10px rgba(0, 0, 0, 0.3);
    margin-bottom: 1px;
    position: relative;
    z-index: 2;
}

.subtitle {
    font-size: 1.8rem;
    font-weight: 500;
    color: #ffd700;
    text-shadow: 1px 1px 5px rgba(0, 0, 0, 0.2);
    position: relative;
    z-index: 2;
    margin-top: 2px;
    margin-bottom: 1px;
}

/* Main Content */
.main-content {
    margin: -30px auto 0;
    position: relative;
    z-index: 1;
    max-width: 1200px;
}

.announcement-card {
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(20px);
    border-radius: 30px;
    padding: 50px;
    box-shadow:
        0 25px 50px rgba(0, 0, 0, 0.1),
        0 0 0 1px rgba(255, 255, 255, 0.3);
    position: relative;
    overflow: hidden;
}

.announcement-card::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 6px;
    background: linear-gradient(
        90deg,
        #0055a5 0%,
        #ffd700 40%,
        #0055a5 60%,
        #ffd700 100%
    );
    border-top-left-radius: 30px;
    border-top-right-radius: 30px;
    box-shadow:
        0 2px 6px rgba(255, 215, 0, 0.4),
        0 2px 6px rgba(0, 85, 165, 0.3);
}

.lead-text {
    font-size: 1.2rem;
    margin-bottom: 30px;
}

/* Table */
.table-container {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    /* smooth scroll iOS */
}

.custom-table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 30px;
    min-width: 500px;
}

.custom-table th,
.custom-table td {
    padding: 15px 20px;
    text-align: center;
}

.custom-table th {
    background: #0055a5;
    color: white;
    font-size: 1.1rem;
}

.custom-table tbody tr:nth-child(even) {
    background: rgba(0, 85, 165, 0.05);
}

.custom-table tbody tr {
    border-bottom: 2px solid #c0dcf6;
}

/* Register Button */
.register-btn {
    display: inline-block;
    background: linear-gradient(45deg, #0055a5, #ffd700);
    color: #fff;
    font-weight: 700;
    padding: 10px 20px;
    border-radius: 12px;
    text-decoration: none;
    box-shadow: 0 5px 15px rgba(0, 85, 165, 0.3);
    transition: all 0.4s ease;
    position: relative;
    overflow: hidden;
}

.register-btn::after {
    content: "";
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.2);
    transform: skewX(-25deg);
    transition: all 0.5s ease;
}

.register-btn:hover::after {
    left: 200%;
}

.register-btn:hover {
    transform: translateY(-3px);
    box-shadow: 0 10px 25px rgba(0, 85, 165, 0.4);
}

.register-btn.disabled {
    pointer-events: none;
    opacity: 0.6;
    cursor: not-allowed;
}

/* Notes */
.notes-section {
    margin-top: 30px;
}

.notes-title {
    font-size: 1.4rem;
    font-weight: 700;
    margin-bottom: 15px;
    color: #dc3545;
}

.notes-list li {
    font-size: 1rem;
    margin-bottom: 12px;
}

/* Footer */
.footer {
    background: #003366;
    padding: 20px 0;
    color: white;
    text-align: center;
}

.footer-text i {
    color: #ffd700;
}

/* Animations */
.fade-in,
.slide-in {
    opacity: 0;
    transform: translateY(30px);
    transition: all 0.6s ease-out;
}

/* Container */
.container {
    width: 100%;
    margin: 0 auto;
    padding: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 25px;
    background: transparent;
    box-sizing: border-box;
    min-height: 100%;
}

/* Text alignment for RTL */
.container.text-center {
    text-align: center;
}

/* Notice Names */
.notice-names {
    list-style: none;
    padding: 0;
    margin: 0;
}

.notice-names li {
    font-size: 0.95rem;
    margin-bottom: 5px;
    color: #003366;
}

/* Registration Message */
.registration-message {
    margin-top: 20px;
    margin-bottom: 20px;
    padding: 15px;
    background: #f1f5f9;
    font-size: 1rem;
    color: #333;
}

p {
    padding: 15px;
}

/* --------------------- */
/* Responsive Adjustments */
/* --------------------- */

/* Medium devices */
@media (max-width: 992px) {
    .container {
        padding: 15px 10px;
        gap: 20px;
    }
}

/* Small devices (mobile) */
@media (max-width: 768px) {
    .main-title {
        font-size: 2rem;
    }

    .subtitle {
        font-size: 1.2rem;
    }

    .lead-text {
        font-size: 1rem;
    }

    .custom-table th,
    .custom-table td {
        padding: 10px 8px;
        font-size: 0.9rem;
    }

    .register-btn {
        padding: 8px 12px;
        font-size: 0.85rem;
    }

    .notes-list li {
        font-size: 0.9rem;
    }
}

/* Extra small devices (phones) */
@media (max-width: 576px) {
    .container {
        width: 95%;
        padding: 10px 5px;
        gap: 15px;
    }

    .announcement-card {
        padding: 25px 15px;
    }

    .logo-container img {
        width: 80px;
    }

    .custom-table {
        min-width: 350px;
    }

    .register-btn {
        padding: 6px 10px;
        font-size: 0.8rem;
    }

    .main-title {
        font-size: 1.6rem;
    }

    .subtitle {
        font-size: 1rem;
    }

    .lead-text {
        font-size: 0.9rem;
    }
}

/* --------------------- */
/* Extra small devices (phones) */
@media (max-width: 576px) {
    .container {
        width: 95%;
        padding: 10px 5px;
        gap: 15px;
    }

    .announcement-card {
        padding: 25px 15px;
    }

    .logo-container img {
        width: 80px;
    }

    .custom-table {
        min-width: 350px;
    }

    .register-btn {
        padding: 6px 10px;
        font-size: 0.8rem;
    }

    .main-title {
        font-size: 1.6rem;
    }

    .subtitle {
        font-size: 1rem;
    }

    .lead-text {
        font-size: 0.9rem;
    }

    /* Notes Section أصغر */
    .notes-section {
        margin-top: 15px;
    }

    .notes-title {
        font-size: 1.1rem;
    }

    .notes-list li {
        font-size: 0.8rem;
        margin-bottom: 8px;
    }

    /* Footer أصغر */
    .footer {
        padding: 15px 0;
    }

    .footer-text {
        font-size: 0.8rem;
    }
}

/* Buttons */
button {
    padding: 8px 15px;
    border-radius: 8px;
    border: none;
    background-color: #0055a5;
    color: white;
    cursor: pointer;
    transition: background 0.3s;
}

button:hover {
    background-color: #003366;
}

/* الخلفية الشفافة للمودال */
.modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    /* شفافية */
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    /* فوق كل المحتوى */
    padding: 10px;
    /* باش المودال ما يلتصقش بالحافة في الموبايل */
}

/* محتوى المودال */
.modal-content {
    background: #fff;
    padding: 25px 30px;
    border-radius: 12px;
    width: 90%;
    max-width: 420px;
    text-align: center;
    box-shadow: 0 5px 25px rgba(0, 0, 0, 0.3);
    animation: fadeIn 0.3s ease;
    position: relative;
}

/* عنوان المودال */
.modal-content h3 {
    margin-bottom: 18px;
    color: #222;
    font-size: 20px;
}

/* الإدخال */
.modal-content input {
    width: 100%;
    padding: 12px;
    margin-bottom: 15px;
    border: 1px solid #ccc;
    border-radius: 8px;
    font-size: 15px;
    outline: none;
    transition: border-color 0.2s ease;
}

.modal-content input:focus {
    border-color: #007bff;
}

/* الأزرار */
.modal-content button {
    margin: 6px;
    padding: 10px 18px;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-size: 15px;
    font-weight: 500;
    transition: all 0.2s ease;
}

.modal-content button:first-of-type {
    background-color: #007bff;
    color: #fff;
}

.modal-content button:first-of-type:hover {
    background-color: #0056b3;
}

.modal-content button:last-of-type {
    background-color: #423a3a;
}

.modal-content button:last-of-type:hover {
    background-color: #bdbdbd;
}

/* أنميشن */
@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(-20px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* Responsive Design */
@media (max-width: 600px) {
    .modal-content {
        width: 100%;
        padding: 20px;
        border-radius: 10px;
    }

    .modal-content h3 {
        font-size: 18px;
    }

    .modal-content input {
        font-size: 14px;
        padding: 10px;
    }

    .modal-content button {
        font-size: 14px;
        width: 100%;
        /* الأزرار تاخذ العرض الكل في الموبايل */
    }
}

.btn-primary {
    display: inline-block;
    background: linear-gradient(45deg, #0055a5, #928122);
    color: #fff;
    font-weight: 700;
    padding: 12px 25px;
    border-radius: 12px;
    text-decoration: none;
    box-shadow: 0 5px 15px rgba(0, 85, 165, 0.3);
    transition: all 0.4s ease;
    position: relative;
    overflow: hidden;
}
</style>
